import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import { Col, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
import { getMinMaxDates } from "../../fiscalYearHelper";
import { CashAccountBalanceCard, AmanatAccountBalanceCard } from "../../BalanceCards";
const CashToAmanatForm = ({
  values,
  errors,
  fundAccountBalances,
  handleInputChange,
  handleDateChange,
  handleFileChange,
  isEdit = false,
  initialDate,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* BALANCE CARDS */}
      <Row style={{ marginBottom: "20px" }}>
        <CashAccountBalanceCard
          balance={fundAccountBalances?.cashAccountBalance}
          effectiveBalance={fundAccountBalances?.cash_effective_balance ?? fundAccountBalances?.cashEffectiveBalance ?? fundAccountBalances?.cashAccountBalance}
          ledgerBalance={fundAccountBalances?.cash_ledger_balance ?? fundAccountBalances?.cashLedgerBalance ?? fundAccountBalances?.cashAccountBalance}
          pendingHolds={fundAccountBalances?.cash_pending_holds ?? fundAccountBalances?.cashPendingHolds ?? 0}
          loading={!fundAccountBalances || fundAccountBalances.cashAccountBalance === undefined}
          colProps={{ xs: "12", md: "6", className: "mb-3" }}
        />
        <AmanatAccountBalanceCard
          balance={fundAccountBalances?.amanatAccountBalance}
          effectiveBalance={fundAccountBalances?.amanat_effective_balance ?? fundAccountBalances?.amanatEffectiveBalance ?? fundAccountBalances?.amanatAccountBalance}
          ledgerBalance={fundAccountBalances?.amanat_ledger_balance ?? fundAccountBalances?.amanatLedgerBalance ?? fundAccountBalances?.amanatAccountBalance}
          pendingHolds={fundAccountBalances?.amanat_pending_holds ?? fundAccountBalances?.amanatPendingHolds ?? 0}
          loading={!fundAccountBalances || fundAccountBalances.amanatAccountBalance === undefined}
          colProps={{ xs: "12", md: "6", className: "mb-3" }}
        />
      </Row>
      <Row>
        {/* FORM FIELDS */}

        {/* Transfer Amount */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="funds_add_fund_amount" />
            </Label>
            <Input
              type="text"
              name="transferAmount"
              placeholder={t("funds_add_fund_amount")}
              value={values.transferAmount || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "transferAmount", value: val },
                  });
                }
              }}
              invalid={!!errors.transferAmount}
            />
            {errors.transferAmount && (
              <FormFeedback>
                <h4>{errors.transferAmount}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Bank Charges */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_bank_charges" />
            </Label>
            <Input
              type="text"
              name="bankCharge"
              placeholder="Bank Charges"
              value={values.bankCharge || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "bankCharge", value: val },
                  });
                }
              }}
              invalid={!!errors.bankCharge}
            />
          </FormGroup>
        </Col>
        {/* Deposit Date */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="dashboard_event_page_date" />
            </Label>
            <DatePicker
              selected={values.depositDate}
              onChange={handleDateChange}
              className={`form-control ${errors.depositDate ? "is-invalid" : ""
                }`}
              minDate={getMinMaxDates(values.depositDate, initialDate).minDate}
              maxDate={getMinMaxDates(values.depositDate, initialDate).maxDate}
              dateFormat="dd/MM/yyyy"
            />
            {errors.depositDate && (
              <div className="invalid-feedback d-block">
                <h4>{errors.depositDate}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* Reference No */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_bank_deposit_slip_number" />
            </Label>
            <Input
              type="text"
              name="referenceNo"
              placeholder="Bank Deposit Slip Number"
              value={values.referenceNo || ""}
              onChange={(e) =>
                handleInputChange({
                  target: { name: "referenceNo", value: e.target.value },
                })
              }
              invalid={!!errors.referenceNo}
            />
            {errors.referenceNo && (
              <div className="invalid-feedback d-block">
                <h4>{errors.referenceNo}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* File Upload */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="deposit_slip" />
            </Label>
            <Input
              type="file"
              accept="image/*,application/pdf"
              name="file"
              onChange={handleFileChange}
              invalid={!!errors.file}
            />
            {errors.file && (
              <FormFeedback>
                <h4>{errors.file}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Memo */}
        <Col md={isEdit ? "12" : "6"}>
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_memo" />
            </Label>
            <Input
              type="textarea"
              name="memo"
              placeholder="Memo"
              value={values.memo}
              onChange={handleInputChange}
              invalid={!!errors.memo}
            />
            {errors.memo && (
              <h4 className="text-error">{errors.memo}</h4>
            )}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
export default CashToAmanatForm;
